import { QueryProvider } from '@/app/providers/QueryProvider';
import { router } from '@/app/router';
import { VersionUpdateBanner } from '@/shared/components/VersionUpdateBanner';
import { RouterProvider } from '@tanstack/react-router';
import { Toaster } from 'sonner';

function App() {
  return (
    <QueryProvider>
      <RouterProvider router={router} />
      <Toaster position="top-right" richColors closeButton />
      {/* version.json 변경 시 새로고침 유도 */}
      <VersionUpdateBanner />
    </QueryProvider>
  );
}

export default App;
